import { styled } from 'styled-components';

import { colors, cssBreakpoints, gutterWidth } from '#/theme/theme';

export const CmsSplitContentTextContentInner_Box_1 = styled.div`
  margin-top: 24px;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    margin-top: 36px;
  }
`;

export const CmsSplitContentTextContentInner_Box_2 = styled.div`
  position: relative;
  height: 100%;

  @media all and (max-width: ${cssBreakpoints.smDown}) {
    &[data-show-background-image] {
      padding: ${gutterWidth / 2}px;
    }

    &[data-show-text-box] {
      padding-right: ${gutterWidth / 3}px;
    }
  }

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    padding-left: ${gutterWidth}px;

    &[data-show-text-box] {
      padding-right: ${gutterWidth}px;
    }

    &[data-appearance='OVERLAPPING'],
    &[data-appearance='FULL_WIDTH'] {
      padding-block: ${gutterWidth}px;
    }
  }
`;

export const CmsSplitContentTextContentInner_Box_3 = styled.div`
  height: 100%;
  width: 100%;
  background: ${colors.white};

  &[data-show-text-box] {
    @media all and (min-width: ${cssBreakpoints.smUp}) {
      box-shadow: 0 0 6px rgb(0 0 0 / 0.3);
    }
  }
`;
